import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { AcknowledgeComponent } from '../acknowledge/acknowledge.component';
import * as $ from 'jquery';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements OnInit {
  rowClassRules;
  private gridApi;
  private gridColumnApi;
  public frameworkComponents;
  defaultColDef = { resizable: true, cellStyle:{'white-space': 'normal','font-size':'14px'} };
  tabToNextCell:any;
  columnDefs = [
    {headerName: 'Alert Date', field: 'created_dt' },
    {headerName: 'Description', field: 'description' },
    {headerName: 'Action', field: 'id',cellRenderer:'viewrenderer' }
];

    rowData = [];
    request = {
      id:[]
    }

  constructor(public toastService:ToastrService, public loginService:LoginService) { }

  ngOnInit() {
    this.frameworkComponents = {
      viewrenderer: AcknowledgeComponent
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellPosition;
      const prevCell = params.previousCellPosition;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action' || (prevCell.column.colDef.headerName === 'Action' && (nextCell.rowIndex !== prevCell.rowIndex ) && nextCell.column.colDef.headerName == 'Alert Date')) {
        return;
      } else {
      return nextCell;
      }
      }; 
    /*this.rowClassRules = {
      "latest-alerts": function(params) {
        return params.data.view_sw == 'N';
    }
  };*/
  this.load();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    setTimeout(()=>{
      this.gridApi.resetRowHeights();
    this.gridApi.forEachNode(function(rowNode) {
      //alert(rowNode.data.description);
      if(rowNode.data.description.length > 40){
        rowNode.setRowHeight(60);
      }
       else{
         //alert("hello");
        rowNode.setRowHeight(40);
       } 
    });
    this.gridApi.onRowHeightChanged();
    },0);
    
    //this.gridApi.setDomLayout("autoHeight");
  }
  load(){
    let request = {
      perId:this.loginService.personId
    };
    this.loginService.loadAlerts(request).subscribe((data:Array<Object>)=>{
      data.forEach((element)=>{
        element['created_dt'] = element['created_dt'].split('T')[0].split('-')[1] + '/' + element['created_dt'].split('T')[0].split('-')[2] + '/' + element['created_dt'].split('T')[0].split('-')[0]
      })
      this.rowData = data;
    },error=>{
      this.toastService.error('Unable to load alerts','My Alerts');
    })
  }
  save(){
      var rowCount = this.gridApi.getDisplayedRowCount();
      var lastGridIndex = rowCount - 1;
      var currentPage = this.gridApi.paginationGetCurrentPage();
      var pageSize = this.gridApi.paginationGetPageSize();
      var startPageIndex = currentPage * pageSize;
      var endPageIndex = (currentPage + 1) * pageSize - 1;
      if (endPageIndex > lastGridIndex) {
        endPageIndex = lastGridIndex;
      }
      this.request.id = [];
      for (var i = startPageIndex; i <= endPageIndex; i++) {
        var rowNode = this.gridApi.getDisplayedRowAtIndex(i);
        this.request.id.push(rowNode.data.id);
      }
  }
  confirm(){
    this.loginService.updateAlerts(this.request).subscribe((data)=>{
      if(data['message'] == 'success'){
        $("#closeAlert").click();
          this.load();
      }
      else{
          this.toastService.error('Record not saved: Please review or contact Help Desk','My Alerts');
      }
  },error=>{
      this.toastService.error('Record not saved: Please review or contact Help Desk','My Alerts');
  })
  }
  focus(event){
    if(event.keyCode == 9){
      this.gridApi.ensureIndexVisible(this.gridApi.paginationGetCurrentPage()*10);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
        return;
      }
      else{
        event.preventDefault();
        this.gridApi.setFocusedCell((this.gridApi.paginationGetCurrentPage()*10), firstCol);
      }
    }
    else{
      return;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/alerts/alerts.component.ts